const BASE_URL = 'https://onyxtms.com';

export const LANDING_PAGE_URL = {
  HOME: BASE_URL,
  CONTACT: `${BASE_URL}/contact`,
  PRIVACY_POLICY: `${BASE_URL}/privacy`,
  TELEMATICS: `${BASE_URL}/telematics`,
} as const;
